import { Component } from '@angular/core';

@Component({
  selector: 'edgvr-front-ui-header-template',
  templateUrl: './header-template.component.html',
})
export class HeaderTemplateComponent {}
